module.exports = __webpack_public_path__ + "img/hydro_units.8ffda3ad.svg";